<div class="welcomeModel">
  <div class="modal-header d-flex justify-content-center">
    <h3 class="modal-title font-bold text-center" id="modal-title">Welcome to Relay !!</h3>
    <button type="button" class="close" aria-label="Close" (click)="cancelModal()">
        <span style="color: white;" aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body" id="modal-body">
    <p class="text-center">Please contact <a href="mailto:grp-relay-team@adobe.com">grp-relay-team@adobe.com</a> to start using Relay.
    </p>
    <p class="text-center">Click <a href="https://wiki.corp.adobe.com/display/Relay/Relay" target="_blank">Wiki</a> to know the onboarding process.</p>
    <div class="text-center">
      <a  (click)="routeToNewProjectPage(true)"> 1) New Project :  </a> <strong>Kickstart a New Project</strong> <br>

      <a (click)="routeToNewProjectPage(false)"> 2) Existing Project : </a> <strong>Access Projects Authored by You or Your Team</strong>
    </div>
    <div class="text-center">
      <button class="btn btn-warning m-2" type="button" (click)="cancelModal()">Close</button>
    </div>
  </div>
</div>